import Request from "../../../helpers/Request";
import LanguageHelper from "../../../helpers/LanguageHelper";
import moment from "moment";

export const ISG_PROFESSIONALS_URL = "/api/osgb-izleme/isg-professionals";

const FILTER_FIELDS = ["documentType", "active", "signaturePinDefined"];

export function buildQueryParams(query, filterProps) {
  const params = {
    page: query.page,
    size: query.pageSize,
    sort: "id,desc",
  };

  if (query.orderBy !== undefined) {
    params.sort = query.orderBy.field + "," + (query.orderDirection || "asc");
  }

  if (query.search !== "") {
    params.search = query.search;
  }

  FILTER_FIELDS.forEach((field) => {
    const value = filterProps && filterProps[field];
    if (value !== "" && value !== null && value !== undefined) {
      params[field] = value;
    }
  });

  return params;
}

const formatDate = (value) =>
  value ? moment(value).format("DD.MM.YYYY") : null;

export default function FetchData(
  query,
  setSnackbar,
  setSnackbarMessage,
  setSeverity,
  setNumOfEntries,
  type,
  filterProps
) {
  const language = LanguageHelper.getLanguage();
  const data = new Promise(async (resolve, reject) => {
    const params = buildQueryParams(query, filterProps);
    const resp = await Request("get", ISG_PROFESSIONALS_URL, null, params);
    if (resp.status !== 200) {
      setSeverity("error");
      setSnackbarMessage(language.etc.fetchingError + resp?.data?.message);
      setSnackbar(true);
    } else {
      const otherData = resp.data;
      const temp = otherData.content.map((entry) => ({
        id: entry.id,
        tcNo: entry.tcNo,
        documentType: entry.documentType,
        firstName: entry.firstName,
        lastName: entry.lastName,
        branch: entry.branch,
        plate: entry.plate,
        active: entry.active,
        signaturePinDefined: entry.signaturePinDefined,
        medulaPasswordDefined: entry.medulaPasswordDefined,
        createdAt: formatDate(entry.createdAt),
        updatedAt: formatDate(entry.updatedAt),
        deletedAt: formatDate(entry.deletedAt),
      }));
      setNumOfEntries(otherData.totalElements);
      resolve({
        data: temp,
        page: otherData.pageable.pageNumber,
        totalCount: otherData.totalElements,
      });
    }
  });
  return data;
}
